import styled from "styled-components";
import { Link } from "react-router-dom";
import { Image } from "semantic-ui-react";

export const Container = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;700&family=Roboto:wght@400;500;700&display=swap");
  width: 100%;
  background: #e3dfdb;
`;

export const Content = styled.div`
  width: 100%;
  background: #e3dfdb;

  display: flex;
  flex-direction: column;
`;

export const Section = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 10px auto;
  background: #ffffff;
  height: 280px;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);

  h4 {
    margin-top: 10px;
    text-align: center;
  }

  div {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 1000px;
    justify-content: center;
    margin: 15px auto;
    display: flex;

    h4 {
      display: flex;
      align-items: flex-start;
      margin-top: 15px;
      font-weight: 700 !important;
      text-align: center;
      font-size: 18px !important;
      height: auto;
      color: #414141 !important;
      text-align: center;
    }

    div {
      width: 295px !important;
    }

    & + div {
      margin-left: 15px;
      flex-direction: column;

      h4 {
        margin-top: ${(props) => (props.top ? `${props.top}px` : "-30px")};
      }
    }
  }
`;

export const Title = styled.label`
  margin-top: 15px;
  font-size: 26px;
  font-weight: 700;
  color: #414141;
  display: flex;
  justify-content: center;
`;

export const Span = styled.span`
  padding: 5px;
  line-height: 12px;
  text-transform: capitalize;
  text-align: center;

  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 200px !important;
  height: 55px !important;
  text-align: center;
  background: rgba(234, 234, 234, 0.7);
  color: #414141 !important;
  font-size: 20px;
  font-weight: 700;
  border: 3px dashed #ccc;
  margin-left: auto !important;
  margin-right: auto !important;
`;

export const SemanticImage = styled(Image)`
  width: 300px !important;
  max-width: none;
  height: 200px;
  margin: 0px auto !important;
  box-shadow: 0 1px 3px rgba(34, 25, 25, 0.4) !important;

  a {
    margin-left: 13px !important;
  }
`;

export const RedirectLink = styled(Link)`
  border: 2px solid #2ecc40;
  width: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto !important;
  margin-top: 20px;
  color: #2ecc40;
  border-radius: 0;
  height: 40px;
  cursor: pointer !important;

  i {
    display: flex;
    align-items: center;
  }

  &:hover {
    background: #2ecc40;
    color: #ffffff;
  }
`;

export const RedirectButton = styled.a`
  border: 2px solid #2ecc40;
  width: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto !important;
  /* margin-right: auto !important; */
  margin-top: 20px;
  color: #2ecc40;
  border-radius: 0;
  height: 40px;
  cursor: pointer !important;

  i {
    display: flex;
    align-items: center;
  }

  &:hover {
    background: #2ecc40;
    color: #ffffff;
  }
`;
